var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown-item',{on:{"click":_vm.submit}},[_vm._v("\n    Enable Default 2FA\n    "),_c('form',{ref:"form",staticClass:"d-none",attrs:{"action":_vm.action,"method":"POST"}},[_c('input',{attrs:{"type":"hidden","name":"_token"},domProps:{"value":_vm.csrfToken}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }